import React from 'react'
import ModalTest from '../../BaseModal'
import * as S from './FieldTypeSelectorStyle'
import { X, ChevronRight, Sliders, Share2 } from 'lucide-react'

interface PropsInterface {
  closeModal: () => void
  onSelectCustomField: () => void
  onSelectIntegratedField: () => void
}

const FieldTypeSelector = ({ closeModal, onSelectCustomField, onSelectIntegratedField }: PropsInterface) => {
  return (
    <ModalTest>
      <S.Container>
        <S.Header>
          <S.Title>Que tipo de campo deseja criar?</S.Title>
          <S.CloseButton onClick={closeModal}>
            <X size={20} />
          </S.CloseButton>
        </S.Header>
        
        <S.OptionsContainer>
          <S.OptionCard onClick={onSelectCustomField}>
            <S.IconContainer>
              <Sliders size={24} />
            </S.IconContainer>
            <S.OptionContent>
              <S.OptionTitle>Campo personalizado</S.OptionTitle>
              <S.OptionDescription>
                Crie um campo independente, da forma que melhor atender às suas necessidades.
              </S.OptionDescription>
            </S.OptionContent>
            <S.ChevronContainer>
              <ChevronRight size={20} />
            </S.ChevronContainer>
          </S.OptionCard>
          
          <S.OptionCard onClick={onSelectIntegratedField}>
            <S.IconContainer>
              <Share2 size={24} />
            </S.IconContainer>
            <S.OptionContent>
              <S.OptionTitle>Campo integrado</S.OptionTitle>
              <S.OptionDescription>
                Crie um campo capaz de ler ou registrar informações em um banco de dados.
              </S.OptionDescription>
            </S.OptionContent>
            <S.ChevronContainer>
              <ChevronRight size={20} />
            </S.ChevronContainer>
          </S.OptionCard>
        </S.OptionsContainer>
        
        <S.Footer>
          <S.CancelButton onClick={closeModal}>Cancelar</S.CancelButton>
        </S.Footer>
      </S.Container>
    </ModalTest>
  )
}

export default FieldTypeSelector
